import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import errorImage from "assets/image/common/404error.png";
import { OutlineRedBtn } from "components/button/Button";

const ErrorContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
    div {
        max-width: 400px;
        max-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
    }
    img {
        display: inline-block;
        width: 80%;
    }
`;

function NotFound() {
    const navigate = useNavigate();
    return (
        <ErrorContainer>
            <div>
                <img src={errorImage} alt="404error" />
                <OutlineRedBtn onClick={() => navigate("/")}>메인으로 이동</OutlineRedBtn>
            </div>
        </ErrorContainer>
    );
}

export default NotFound;